"use client";

import { useEffect, type ReactNode } from "react";
import { reportError } from "@/lib/report-error";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: Props): ReactNode {
  useEffect(() => {
    reportError("Unhandled error (global boundary)", error);
  }, [error]);

  return (
    <html lang="nl">
      <body>
        <main className="flex min-h-screen items-center justify-center px-4">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-semibold text-gray-900">Er ging iets mis</h1>
            <p className="mt-2 text-gray-600">
              Er is een onverwachte fout opgetreden. Probeer het opnieuw.
            </p>
            <button
              type="button"
              onClick={() => reset()}
              className="mt-6 inline-flex items-center justify-center rounded-md bg-gray-900 px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
            >
              Probeer opnieuw
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
